import { FunctionComponent } from "preact";
import { useEffect, useRef } from "preact/hooks";

const FocusTrap: FunctionComponent<{ active?: boolean }> = ({ children, active = true }) => {
  const focusWrapper = useRef<HTMLDivElement | null>(null);
  const focusReturn = useRef<HTMLDivElement | null>(null);
  const focusCatcherStart = useRef<HTMLDivElement | null>(null);
  const focusCatcherEnd = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!active) return;

    function handleTabOutStart() {
      focusReturn?.current?.focus();
    }
    function handleTabOutEnd() {
      focusWrapper?.current?.focus();
    }

    focusCatcherStart.current?.addEventListener('focusin', handleTabOutStart);
    focusCatcherEnd.current?.addEventListener('focusin', handleTabOutEnd);
    return () => {
      focusCatcherStart.current?.removeEventListener('focusin', handleTabOutStart);
      focusCatcherEnd.current?.removeEventListener('focusin', handleTabOutEnd);
    }
  }, [focusCatcherStart, focusCatcherEnd, focusWrapper, active]);

  return (
    <>
      <div ref={focusCatcherStart} tabIndex={0}/>
      <div ref={focusWrapper} tabIndex={-1}>
        {children}
        <div ref={focusReturn} tabIndex={-1}/>
      </div>
      <div ref={focusCatcherEnd} tabIndex={0}/>
    </>
  )
}

export default FocusTrap;

